import * as CL from '@design-system/component-library';
import { SubscriptionType } from '../../generated/api/models.js';
import { getPbxFields } from './subscriptionDetailsPbx.js';
import { getPbxLiteFields } from './subscriptionDetailsPbxLite.js';
import type { CLDescriptionItem } from '../../common/types/componentLibrary';
import type { AddOn, NumberRange, Subscription, SubscriptionDetailsPbxSolution } from '../../generated/api/models.js';

const renderRangeOfNumbers = (numberRanges: NumberRange[] = [], filterCondition: NumberRange.RangeTypeEnum) =>
  numberRanges
    .filter(numberRange => numberRange.rangeType === filterCondition)
    .map(numberRange => (
      <div key={numberRange.rangeId}>
        {numberRange.startNumber} - {numberRange.endNumber}
      </div>
    ));

export const renderContent = (items: CLDescriptionItem[]) => <CL.Description items={items} />;

export const getPbxTechnicalDetailsContent = (
  subscription: Subscription,
  mobilePbx: SubscriptionDetailsPbxSolution
) => {
  const fields =
    subscription.subscriptionType === SubscriptionType.MOBILE_PBX_LITE
      ? getPbxLiteFields(mobilePbx, renderRangeOfNumbers, subscription.subscriptionPurposeOfUse)
      : getPbxFields(mobilePbx?.numberRanges, renderRangeOfNumbers);
  return renderContent(fields);
};

export enum ExceptionalAddOnGuid {
  LandLine = 'd071f5c9-9310-859a-5a97-67a8e013bb68',
}

export const hasRejectedAddOns = (subscription: Subscription): boolean => {
  const rejectedAddons: AddOn[] | undefined = subscription.details?.selectedAddOns?.filter(
    addon => addon.addOnCode === ExceptionalAddOnGuid.LandLine
  );

  return !!(rejectedAddons && rejectedAddons.length > 0);
};
